<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">文章标题</span>
        <Input v-model="searchParams.title" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">文章类型</span>
        <Select v-model="searchParams.articleType" transfer placeholder="请选择文章类型" clearable multiple>
          <Option value="11">图文</Option>
          <Option value="12">视频</Option>
          <Option value="15">图片素材</Option>
          <Option value="16">视频素材</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">关联产品</span>
        <Select :label-in-value="true" v-model="searchParams.productCode" placeholder="请选择" clearable multiple transfer filterable>
          <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{ product.productName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">发布时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch(), (searchParams.date = []), getClassArr(false)">重置</Button>
      </div>
    </div>

    <div class="tab-one">
      <Tabs v-model="activeTab" @on-click="changeTabOne">
        <TabPane :label="item.name + '(' + item.counts + ')'" :name="item.id" v-for="(item, i) in tabOneList" :key="i"></TabPane>
      </Tabs>
    </div>

    <div class="tab-two" v-if="tabTwoList.length">
      <div class="tab-item" v-for="(item, index) in tabTwoList" :key="index" :class="{ active: tabTwoAction == index }" @click="changeTabTwo(item, index)">
        <span>{{ item.name }}</span>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table" v-if="tableData.length">
      <div class="table-container" v-for="(item, index) in tableData" :key="index">
        <div class="left">
          <img v-if="item.coverImg" :src="item.coverImg" />
          <img v-if="item.articleType==16&&!item.coverImg" src="@/static/images/contentManage/08.png">
          <div class="text-box">
            <div class="title-new">
              <span class="title" @click="toImportPage(item)">{{ item.title }}</span>
              <img v-if="getTime(item.publishTime)" src="@/static/images/contentManage/09.png">
            </div>            
            <span class="desc">{{ item.articleDescribe }}</span>
            <div class="tag">
              <div class="tag-item" v-for="(tag, tagIndex) in item.tagList" :key="tagIndex">{{ tag }}</div>
            </div>
            <div class="time-box">
              <div class="time">
                <span class="lable">发布时间：</span>
                <span class="value">{{ item.publishTime }}</span>
              </div>
              <!-- <div class="imports-box">
                <span class="lable">导入次数：</span>
                <span class="value">{{ item.importNums }}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right">
          <div class="btn details" @click="toImportPage(item)" v-if="$units.pointAction('content_6_0')">查看详情</div>
          <div class="btn import-btn hover-import" v-if="$units.pointAction('content_6_1')&&item.isImport == 0" @click="$refs.importArticleRef.open(item, 0)">导入</div>
          <div class="btn import-release-btn block-btn" v-if="$units.pointAction('content_6_1')&&item.isImport == 0" @click="$refs.importArticleRef.open(item, 1)">导入并发布</div>
          <div class="btn imported" v-if="item.isImport == 1">已导入</div>
        </div>
      </div>
    </div>
    <noData v-if="!tableData.length"></noData>

    <!-- 导入 -->
    <articleMaterialsImport ref="importArticleRef" @success="getList()"></articleMaterialsImport>

    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import { filterTime } from '@/api/filter';
import noData from '@/components/commons/noData';
import articleMaterialsImport from './articleMaterialsImport';

export default {
  mixins: [pageTool],
  components: {
    noData,
    articleMaterialsImport
  },
  data() {
    return {
      tableLoading: false, //表格loading
      searchParams: {},
      productListArr: [],
      tableData: [],
      parentList: [],
      activeTab: '',
      tabOneList: [],
      tabTwoList: [],
      tabTwoAction: 0,
      tabTwoActionId: '',
      pageSize: 5,
      pageNum: 1
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    async getData() {
      this.getProductList();
      await this.getClassArr(true);
      this.activeTab = this.tabOneList[0].id;
      this.tabTwoAction = 0;
      this.getList();
    },

    getTime(time) {
      let nowdate = filterTime(new Date(), 'YYYY-MM-DD');
      if(filterTime(time, 'YYYY-MM-DD') == nowdate) {
        return true
      }else{
        return false
      }
    },

    // 搜索
    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getClassArr(false);
    },

    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.searchParams);
      if (params.date && params.date.length) {
        params.startPublishTime = params.date[0] && filterTime(params.date[0], 'YYYY-MM-DD');
        params.endPublishTime = params.date[1] && filterTime(params.date[1], 'YYYY-MM-DD');
        delete params.date;
      } else {
        delete params.date;
      }
      return params;
    },

    // tab分类
    getClassArr(query) {
      return this.$http({
        url: '/buz/cms/materialsLibrary/columnTree/1',
        type: 'POST',
        data: {
          ...this.getParams()
        }
      }).then(res => {
        this.tabOneList = res.data;
        if (res.data && res.data[0].children) {
          if (query) {
            this.tabTwoList = res.data[0].children;
            this.tabTwoActionId = this.tabTwoList[0].id;
          }
        } else {
          this.tabTwoActionId = res.data[0].id;
        }
      });
    },

    // 产品
    getProductList() {
      this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.productListArr = res.data;
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/cms/materialsLibrary/queryArticlePage',
        type: 'POST',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          columnIds: [this.tabTwoActionId],
          ...this.getParams()
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 切换一级分类
    changeTabOne(val) {
      this.tabTwoList = [];
      this.tabTwoAction = 0;
      this.pageNum = 1;
      if (!val) {
        this.tabTwoActionId = '';
      } else {
        this.tabOneList.map(item => {
          if (item.id == val) {
            if (item.children && item.children.length) {
              this.tabTwoList = item.children;
              this.tabTwoActionId = item.children[0].id;
            } else {
              this.tabTwoList = [];
              this.tabTwoActionId = val;
            }
          }
        });
      }
      this.getList();
    },

    changeTabTwo(item, index) {
      this.tabTwoAction = index;
      this.tabTwoActionId = item.id;
      this.pageNum = 1;
      this.getList();
    },

    pageChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(pageNum);
    },

    // 导入详情
    toImportPage(item) {
      localStorage.setItem('formDetailPage', 1);
      this.$router.push({
        path: '/contentManagement/articleMaterialsDetail',
        query: {
          id: item.id,
          title: item.title,
          url: item.url
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-one {
  position: relative;
  /deep/.ivu-tabs-nav {
    max-width: 80%;
    overflow-x: auto;
  }
  .ivu-tabs {
    height: 42px;
    margin-bottom: 14px;
  }
  /deep/ .ivu-tabs-tab-active {
    font-weight: bold;
  }
}

.tab-two {
  display: flex;
  margin-bottom: 15px;
  .tab-item {
    margin-right: 15px;
    padding: 7px 16px;
    background: #f5f7f9;
    border-radius: 2px;
    cursor: pointer;
    span {
      font-size: 12px;
      color: #727c8e;
    }
    &.active {
      background: #236dff;
      span {
        color: #ffffff;
      }
    }
  }
}
.table {
  border: 1px solid #e3e5e8;
  border-bottom: none;
  .table-container {
    display: flex;
    align-items: center;
    padding: 22px 20px 20px 20px;
    border-bottom: 1px solid #e3e5e8;
    .left {
      display: flex;
      align-items: center;
      img {
        max-width: 168px;
        max-height: 120px;
        object-fit: contain;
        border-radius: 4px;
        margin-right: 23px;
      }
      .text-box {
        display: flex;
        flex-direction: column;
        margin-bottom: auto;
        .title-new {
          display: flex;
          position: relative;
          .title {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: bold;
            text-decoration: underline;
            color: #236dff;
            cursor: pointer;
          }
          img {
            width: 17px;
            height: 20px;
            margin-left: 5px;
          }
        }
        
        .desc {
          font-size: 13px;
          color: #515c6f;
        }
      }
      .tag {
        display: flex;
        margin-top: 10px;
        .tag-item {
          padding: 4px 8px;
          border-radius: 2px;
          background: #ecf1fa;
          margin-right: 18px;
          font-size: 12px;
          color: #2e4f96;
        }
      }
      .time-box {
        display: flex;
        margin-top: 20px;
        .time {
          margin-right: 40px;
          font-size: 13px;
          .lable {
            color: #727c8e;
          }
          .value {
            color: #3c464f;
          }
        }
        .imports-box {
          font-size: 13px;
          .lable {
            color: #727c8e;
          }
          .value {
            color: #3c464f;
          }
        }
      }
    }
    .right {
      margin-left: auto;
      display: flex;
      flex-direction: column;
      .btn {
        width: 125px;
        height: 36px;
        border-radius: 2px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        &.details {
          background: #236dff;
          margin-bottom: 15px;
        }
        &.import-btn {
          background: #fff !important;
          color: #236dff !important;
          border: 1px solid #236dff;
          transition: 0.4s;
        }
        &.import-btn:hover {
          background: #236dff !important;
          color: #fff !important;
          border-radius: 0px !important;
        }
        &.import-release-btn {
          background: #fff !important;
          color: #236dff !important;
          border: 1px solid #236dff !important;
          border-radius: 0 !important;
        }
        &.import-release-btn:hover {
          background: #236dff !important;
          color: #fff !important;
          border-radius: 0px !important;
        }
        &.imported {
          border: 1px solid #ced1d5;
          color: #a8adb7;
          cursor: default;
        }
      }
      .hover-import:hover + .block-btn {
        display: block;
      }
      .block-btn {
        display: none;
        text-align: center;
        line-height: 36px;
        background: #fff !important;
        color: #236dff !important;
        border: 1px solid #236dff !important;
        border-radius: 0 !important;
      }
      .block-btn:hover {
        display: block;
      }
    }
  }
}
</style>
